export default "__VITE_ASSET__CXh5aagU__"